<template>
  <v-expansion-panels
    v-model="panel"
    v-if="componentVisible && showPanel"
    class="accordion-list-components"
    hover
    focusable
    multiple
  >
    <v-expansion-panel>
      <v-expansion-panel-header>
        <span class="text-subtitle-2 font-weight-medium grey--text text--darken-3">{{ schema.title }}</span>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <component :is="dynamicComponent" :value="value" :model="model" :schema="schema" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { abstractField } from 'vue-form-generator';

import * as HANDLERS from '@/helpers/types/handlers';
import eventBus from 'vue-option-events';

export default {
  mixins: [abstractField],

  data: () => ({
    panel: [],
    showPanel: true
  }),

  mounted() {
    if ('showPanel' in this.schema) this.panel = this.schema.showPanel;

    // --> Remove TabConditions da masterDetail, caso não tenha TABS no schema!
    if (this.schema.component === 'dev-tab-conditions' && !('tabs' in this.devSchema[this.currentMode]))
      this.showPanel = false;

    if ('typeComponent' in this.schema && this.schema.typeComponent == 'step') this.showPanel = true;
  },

  computed: {
    devSchema() {
      return this.$store.getters['dev/getSchema'];
    },

    currentMode() {
      return this.$store.getters['dev/getCurrentMode'];
    },

    dynamicComponent() {
      if (this.schema.component) return () => import(`@/components/dev/${this.schema.component}`);

      return null;
    },

    componentVisible() {
      if (this.schema.attrShowComponent) return this.model[this.schema.attrShowComponent];

      return true;
    }
  }
};
</script>
